import { REFERENCE_TYPE_TECHNIQUE } from '@/configuration/parametrage/nomenclatureTypeConf';
import { JSON_DEFAULT_SCHEMA } from '@/configuration/jsonEditor/jsonEditorConfig';

export default function genererNomenclatureType() {
  return {
    libelle: '',
    schema: JSON_DEFAULT_SCHEMA,
    reference: REFERENCE_TYPE_TECHNIQUE,
    actif: true,
  };
}
